export default __webpack_public_path__ + "static/media/013-Hawkege.c03967f2.svg";